import React, { useEffect, useRef, useState } from "react";
import AccordionBar from "./AccordionBar";
import AnalyticsStore from "../../store/AnalyticsStore";
import ChildBar from "./ChildBar";
import { getCookie } from "../../utils/cookie";

export const colors = [
  { border: "#034DA2", background: "#034DA222" },
  { border: "#6B4BA9", background: "#6B4BA922" },
  { border: "#FF5F59", background: "#FF5F5922" },
  { border: "#EEB01E", background: "#EEB01E22" },
];

export default function AccordionBarChart({
  overall = false,
  data,
  containerStyles,
  percentTextColor = null,
  className,
  colorsArray = colors,
}) {
  const [showTextIndex, setShowTextIndex] = useState(-1);
  const [clicked, setClicked] = useState(-1);
  const [showRecordCount, setShowRecordCount] = useState(5);
  const userId = AnalyticsStore?.overall?.userId || getCookie("userid");
  const accordionRef = useRef(null);

  const handleToggle = (index) => {
    if (clicked === index) {
      setClicked(-1);
    } else {
      setClicked(index);
    }
    let e = window.event;
    if (false) {
      // showText
      e.cancelBubble = true;
      if (e.stopPropagation) e.stopPropagation();
    }
    if (showRecordCount > 5) {
      setTimeout(() => {
        const itemToScroll = document.getElementById(`item-${index}`);
        itemToScroll.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 200);
    }
  };

  const changeShowTextIndex = (index) => {
    setShowTextIndex(index);
  };

  useEffect(() => {
    setShowRecordCount(5);
  }, [clicked]);

  useEffect(() => {
    setClicked(-1);
  }, [userId]);

  return (
    <ul
      style={{ ...containerStyles, width: "100%" }}
      className={`accordion ${className}`}
    >
      {data?.map((item1, index) => (
        <>
          <AccordionBar
            accordionRef={accordionRef}
            item={item1}
            index={index}
            handleToggle={handleToggle}
            clicked={clicked}
            percentTextColor={percentTextColor}
            colorsArray={colorsArray}
          />

          <div
            style={{
              marginTop: 5,
            }}
          >
            {item1?.instrumentAllocations
              ?.slice(0, showRecordCount)
              .map((item, indexOfSubInstrument) => (
                <ChildBar
                  index={index}
                  indexOfSubInstrument={indexOfSubInstrument}
                  overall={overall}
                  colorsArray={colorsArray}
                  item={item}
                  percentTextColor={percentTextColor}
                  clicked={clicked}
                  showTextIndex={showTextIndex}
                  setShowTextIndex={changeShowTextIndex}
                />
              ))}
            {item1?.instrumentAllocations?.length > showRecordCount &&
              clicked === index && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    className="show-more-container"
                    onClick={() => setShowRecordCount(showRecordCount + 20)}
                    style={{
                      borderWidth: 0,
                      backgroundColor: "transparent",
                      alignSelf: "center",
                      marginTop: "auto",
                      marginBottom: 15,
                    }}
                  >
                    Show more
                    <svg
                      style={{ marginLeft: 10 }}
                      width="26"
                      height="14"
                      viewBox="0 0 26 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.59448 0.624337C2.19414 0.331437 2.91765 0.580113 3.21049 1.17981C3.67945 2.14007 4.25077 3.01986 4.90614 3.80201C4.93973 3.83717 4.97078 3.87391 4.99931 3.91185C5.95556 5.02617 7.08475 5.93593 8.33202 6.58964C8.36497 6.60269 8.39762 6.61731 8.4299 6.6335C8.46732 6.65235 8.50334 6.67277 8.53793 6.69476C9.91212 7.37699 11.4231 7.75133 13 7.75133C14.5766 7.75133 16.0877 7.37699 17.4619 6.69476C17.4966 6.67277 17.5326 6.65235 17.57 6.6335C17.6024 6.61731 17.6352 6.60269 17.6682 6.58964C18.9141 5.93653 20.0422 5.02811 20.9978 3.91548C21.028 3.875 21.0612 3.83584 21.0972 3.79851C21.7514 3.01732 22.3217 2.13886 22.79 1.18017C23.0831 0.580596 23.8066 0.331921 24.4062 0.624821C25.0058 0.917842 25.2544 1.64139 24.9614 2.24097C24.5647 3.05309 24.1019 3.82255 23.5805 4.5397L25.3335 6.29275C25.8054 6.76472 25.8054 7.52972 25.3335 8.00158C24.8616 8.47355 24.0966 8.47355 23.6246 8.00158L22 6.37697C21.2981 7.06765 20.5305 7.68028 19.7079 8.20095L20.7258 10.2305C21.025 10.827 20.7841 11.5531 20.1875 11.8523C19.591 12.1515 18.8649 11.9104 18.5657 11.314L17.5549 9.2986C16.4964 9.71753 15.3752 9.9952 14.2083 10.1093V12.5847C14.2083 13.252 13.6674 13.793 13 13.793C12.3326 13.793 11.7917 13.252 11.7917 12.5847V10.1093C10.6248 9.9952 9.50351 9.71753 8.44503 9.2986L7.43426 11.314C7.13509 11.9104 6.40898 12.1515 5.81245 11.8523C5.21593 11.5531 4.97489 10.827 5.27406 10.2305L6.29199 8.20095C5.46949 7.68016 4.70192 7.06753 4.00001 6.37685L2.37526 8.00158C1.90337 8.47355 1.1383 8.47355 0.666409 8.00158C0.19453 7.52972 0.19453 6.76472 0.666409 6.29275L2.41975 4.53946C1.89838 3.82219 1.43561 3.0526 1.03895 2.24024C0.746099 1.64067 0.994822 0.917116 1.59448 0.624337Z"
                        fill="#03002F"
                      />
                    </svg>
                  </button>
                </div>
              )}
          </div>
        </>
      ))}
    </ul>
  );
}
